import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors, TextColors, TextOpacities } from '@/utils/constants';
import { hexToRGBA } from '@/utils/helpers';

const darkTheme = {
  root: {
    '& $breadcrumb': {
      '& a': {
        color: SecondaryColors.main,

        '&:hover': {
          color: SecondaryColors.light,
        },
      },
      '& .MuiBreadcrumbs-separator': {
        color: hexToRGBA(TextColors.light, TextOpacities.light3),
      },
    },
  },
};

const lightTheme = {
  root: {
    '& $breadcrumb': {
      '& a': {
        color: SecondaryColors.dark,

        '&:hover': {
          color: SecondaryColors.main,
        },
      },
      '& .MuiBreadcrumbs-separator': {
        color: hexToRGBA(TextColors.dark, TextOpacities.dark3),
      },
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      flexGrow: 1,
    },
    columns: {
      marginTop: muiTheme.spacing(3),

      [muiTheme.breakpoints.up('md')]: {
        marginTop: muiTheme.spacing(6),
      },
    },
    breadcrumb: {},
    content: {
      display: 'flex',
      flexDirection: 'column',

      '& > *': {
        width: '100%',
      },
    },
    carousel: {
      cursor: 'zoom-in',

      '& + *': {
        marginTop: muiTheme.spacing(3),
      },

      '& figure': {
        height: '220px',
      },

      '& picture': {
        transition: 'transform 5s ease-in',
      },

      '&:hover picture': {
        transform: 'scale(1.15)',
      },

      '& [role="button"]': {
        backgroundColor: 'transparent !important',
      },
    },
  }),
  { name: 'GenPressRelease' },
);

export default useStyles;
